import { render, staticRenderFns } from "./shopFlow.vue?vue&type=template&id=53a14c9d&scoped=true"
import script from "./shopFlow.vue?vue&type=script&lang=js"
export * from "./shopFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a14c9d",
  null
  
)

export default component.exports